"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _decoration = require("@/api/decoration");
var _product = require("@/api/product");
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'DecorationMaterial',
  data: function data() {
    return {
      activeTab: 'sales',
      loading: false,
      drawerVisible: false,
      createVisible: false,
      creating: false,
      projectOptions: [],
      productOptions: [],
      createForm: {
        projectId: null,
        productId: null,
        quantity: 1,
        salePrice: 0,
        remark: ''
      },
      detail: null,
      detailType: 'sales',
      searchForm: {
        page: 1,
        limit: this.$constants.page.limit[0],
        keywords: '',
        status: ''
      },
      tableData: {
        data: [],
        total: 0
      },
      payTag: {
        unpaid: 'warning',
        partial: 'warning',
        paid: 'success',
        refunded: 'info'
      },
      salesTag: {
        draft: 'info',
        pending: 'warning',
        effective: 'success',
        completed: 'success',
        cancelled: 'danger',
        returned: 'danger'
      },
      purchaseTag: {
        draft: 'info',
        confirmed: 'warning',
        fulfilling: '',
        completed: 'success',
        cancelled: 'danger',
        returned: 'danger'
      },
      salesStatuses: [{
        value: 'draft',
        label: '草稿'
      }, {
        value: 'pending',
        label: '待审核'
      }, {
        value: 'effective',
        label: '已生效'
      }, {
        value: 'completed',
        label: '已完成'
      }, {
        value: 'cancelled',
        label: '已取消'
      }],
      purchaseStatuses: [{
        value: 'draft',
        label: '草稿'
      }, {
        value: 'confirmed',
        label: '已确认'
      }, {
        value: 'fulfilling',
        label: '履约中'
      }, {
        value: 'completed',
        label: '已完成'
      }, {
        value: 'cancelled',
        label: '已取消'
      }]
    };
  },
  computed: {
    currentStatuses: function currentStatuses() {
      return this.activeTab === 'sales' ? this.salesStatuses : this.purchaseStatuses;
    },
    pageAmount: function pageAmount() {
      var _this = this;
      return this.tableData.data.reduce(function (sum, item) {
        return sum + Number((_this.activeTab === 'sales' ? _this.sales(item) : _this.purchase(item)).payableAmount || 0);
      }, 0);
    },
    pendingCount: function pendingCount() {
      var _this2 = this;
      return this.tableData.data.filter(function (item) {
        var value = _this2.activeTab === 'sales' ? _this2.sales(item) : _this2.purchase(item);
        return _this2.activeTab === 'sales' ? ['draft', 'pending'].includes(value.orderStatus) : ['draft', 'confirmed', 'fulfilling'].includes(value.status);
      }).length;
    },
    completedCount: function completedCount() {
      var _this3 = this;
      return this.tableData.data.filter(function (item) {
        return (_this3.activeTab === 'sales' ? _this3.sales(item).orderStatus : _this3.purchase(item).status) === 'completed';
      }).length;
    },
    detailOrder: function detailOrder() {
      return this.detailType === 'sales' ? this.sales(this.detail) : this.purchase(this.detail);
    },
    detailNo: function detailNo() {
      return this.detailOrder.salesOrderNo || this.detailOrder.purchaseOrderNo || '';
    },
    detailStatus: function detailStatus() {
      return this.detailType === 'sales' ? this.salesStatusText(this.detailOrder.orderStatus) : this.purchaseStatusText(this.detailOrder.status);
    }
  },
  created: function created() {
    this.getList();
  },
  methods: {
    sales: function sales(item) {
      return item && (item.salesOrder || item.order) || {};
    },
    purchase: function purchase(item) {
      return item && (item.purchaseOrder || item.order) || {};
    },
    supplierName: function supplierName(item) {
      return item && item.supplier && item.supplier.entityName || '--';
    },
    money: function money(value) {
      return Number(value || 0).toFixed(2);
    },
    payText: function payText(value) {
      return {
        unpaid: '待支付',
        partial: '部分支付',
        paid: '已支付',
        refunded: '已退款'
      }[value] || value;
    },
    fulfilmentText: function fulfilmentText(value) {
      return {
        pending: '待处理',
        pending_purchase: '待采购',
        purchasing: '采购中',
        pending_appointment: '待预约',
        pending_shipment: '待发货',
        pending_receipt: '待签收',
        pending_installation: '待安装',
        after_sale: '售后',
        completed: '已完成'
      }[value] || value;
    },
    salesStatusText: function salesStatusText(value) {
      return {
        draft: '草稿',
        pending: '待审核',
        effective: '已生效',
        completed: '已完成',
        cancelled: '已取消',
        returned: '已退单'
      }[value] || value;
    },
    purchaseStatusText: function purchaseStatusText(value) {
      return {
        draft: '草稿',
        confirmed: '已确认',
        fulfilling: '履约中',
        completed: '已完成',
        cancelled: '已取消',
        returned: '已退采'
      }[value] || value;
    },
    getList: function getList() {
      var _this4 = this;
      this.loading = true;
      var api = this.activeTab === 'sales' ? _decoration.decorationSalesOrderListApi : _decoration.decorationPurchaseOrderListApi;
      api(this.searchForm).then(function (res) {
        _this4.tableData.data = res.list || [];
        _this4.tableData.total = res.total || 0;
      }).finally(function () {
        _this4.loading = false;
      });
    },
    handleTabChange: function handleTabChange() {
      this.searchForm.page = 1;
      this.searchForm.status = '';
      this.detail = null;
      this.getList();
    },
    handleSearch: function handleSearch() {
      this.searchForm.page = 1;
      this.getList();
    },
    handleReset: function handleReset() {
      this.searchForm = {
        page: 1,
        limit: this.searchForm.limit,
        keywords: '',
        status: ''
      };
      this.getList();
    },
    handleSizeChange: function handleSizeChange(value) {
      this.searchForm.limit = value;
      this.searchForm.page = 1;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(value) {
      this.searchForm.page = value;
      this.getList();
    },
    openSalesDetail: function () {
      var _openSalesDetail = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(row) {
        var _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              _context.n = 1;
              return (0, _decoration.decorationSalesOrderDetailApi)(this.sales(row).id);
            case 1:
              this.detail = _context.v;
              this.detailType = 'sales';
              this.drawerVisible = true;
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              this.$message.error(_t.message || '销售订单详情加载失败');
            case 3:
              return _context.a(2);
          }
        }, _callee, this, [[0, 2]]);
      }));
      function openSalesDetail(_x) {
        return _openSalesDetail.apply(this, arguments);
      }
      return openSalesDetail;
    }(),
    openPurchaseDetail: function () {
      var _openPurchaseDetail = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(row) {
        var _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              _context2.n = 1;
              return (0, _decoration.decorationPurchaseOrderDetailApi)(this.purchase(row).id);
            case 1:
              this.detail = _context2.v;
              this.detailType = 'purchase';
              this.drawerVisible = true;
              _context2.n = 3;
              break;
            case 2:
              _context2.p = 2;
              _t2 = _context2.v;
              this.$message.error(_t2.message || '采购订单详情加载失败');
            case 3:
              return _context2.a(2);
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function openPurchaseDetail(_x2) {
        return _openPurchaseDetail.apply(this, arguments);
      }
      return openPurchaseDetail;
    }(),
    confirmSales: function confirmSales(row, action) {
      var _this5 = this;
      var labels = {
        approve: '审核通过',
        pay: '确认收款',
        cancel: '取消订单'
      };
      var order = this.sales(row);
      this.$confirm("".concat(labels[action], "\u9500\u552E\u8BA2\u5355\u201C").concat(order.salesOrderNo, "\u201D\uFF1F"), '销售订单管理', {
        type: action === 'cancel' ? 'warning' : 'info'
      }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var result, _t3;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _context3.p = 0;
              _context3.n = 1;
              return (0, _decoration.decorationSalesOrderActionApi)(order.id, {
                action: action,
                version: order.version
              });
            case 1:
              result = _context3.v;
              if (_this5.detail && _this5.sales(_this5.detail).id === order.id) _this5.detail = result;
              _context3.n = 2;
              return _this5.getList();
            case 2:
              _this5.$message.success("".concat(labels[action], "\u6210\u529F"));
              _context3.n = 4;
              break;
            case 3:
              _context3.p = 3;
              _t3 = _context3.v;
              _this5.$message.error(_t3.message || '销售订单操作失败');
            case 4:
              return _context3.a(2);
          }
        }, _callee3, null, [[0, 3]]);
      }))).catch(function () {});
    },
    purchaseActions: function purchaseActions(order) {
      if (order.status === 'draft') return [{
        value: 'confirm',
        label: '确认采购'
      }];
      if (order.status === 'confirmed' && order.payStatus !== 'paid') return [{
        value: 'pay',
        label: '确认付款'
      }];
      var map = {
        pending_shipment: {
          value: 'ship',
          label: '确认发货'
        },
        pending_receipt: {
          value: 'receive',
          label: '确认签收'
        },
        pending_installation: {
          value: 'install',
          label: '确认安装'
        }
      };
      if (map[order.fulfilmentStatus]) return [map[order.fulfilmentStatus]];
      if (order.status === 'fulfilling') return [{
        value: 'complete',
        label: '完成采购'
      }];
      return [];
    },
    confirmPurchase: function confirmPurchase(row, action) {
      var _this6 = this;
      var labels = {
        confirm: '确认采购',
        pay: '确认付款',
        ship: '确认发货',
        receive: '确认签收',
        install: '确认安装',
        complete: '完成采购',
        cancel: '取消采购'
      };
      var order = this.purchase(row);
      this.$confirm("".concat(labels[action], "\u91C7\u8D2D\u5355\u201C").concat(order.purchaseOrderNo, "\u201D\uFF1F"), '采购履约管理', {
        type: action === 'cancel' ? 'warning' : 'info'
      }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var result, _t4;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              _context4.p = 0;
              _context4.n = 1;
              return (0, _decoration.decorationPurchaseOrderActionApi)(order.id, {
                action: action,
                version: order.version
              });
            case 1:
              result = _context4.v;
              if (_this6.detail && _this6.purchase(_this6.detail).id === order.id) _this6.detail = result;
              _context4.n = 2;
              return _this6.getList();
            case 2:
              _this6.$message.success("".concat(labels[action], "\u6210\u529F"));
              _context4.n = 4;
              break;
            case 3:
              _context4.p = 3;
              _t4 = _context4.v;
              _this6.$message.error(_t4.message || '采购订单操作失败');
            case 4:
              return _context4.a(2);
          }
        }, _callee4, null, [[0, 3]]);
      }))).catch(function () {});
    },
    openCreateSales: function openCreateSales() {
      this.createForm = {
        projectId: null,
        productId: null,
        quantity: 1,
        salePrice: 0,
        remark: '后台代下单'
      };
      this.createVisible = true;
    },
    loadCreateOptions: function () {
      var _loadCreateOptions = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var _yield$Promise$all, _yield$Promise$all2, projects, products;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _context5.n = 1;
              return Promise.all([(0, _decoration.decorationProjectListApi)({
                page: 1,
                limit: 100
              }), (0, _product.productLstApi)({
                page: 1,
                limit: 50,
                type: 1
              })]);
            case 1:
              _yield$Promise$all = _context5.v;
              _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
              projects = _yield$Promise$all2[0];
              products = _yield$Promise$all2[1];
              this.projectOptions = projects.list || [];
              this.productOptions = (products.list || []).map(function (item) {
                return {
                  id: item.id,
                  name: item.name,
                  price: item.price
                };
              });
            case 2:
              return _context5.a(2);
          }
        }, _callee5, this);
      }));
      function loadCreateOptions() {
        return _loadCreateOptions.apply(this, arguments);
      }
      return loadCreateOptions;
    }(),
    onCreateProductChange: function onCreateProductChange(productId) {
      var product = this.productOptions.find(function (item) {
        return item.id === productId;
      });
      if (product) this.createForm.salePrice = Number(product.price || 0);
    },
    submitCreateSales: function () {
      var _submitCreateSales = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var _t5;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.p = _context6.n) {
            case 0:
              if (!(!this.createForm.projectId || !this.createForm.productId)) {
                _context6.n = 1;
                break;
              }
              this.$message.warning('请选择工地和商品');
              return _context6.a(2);
            case 1:
              this.creating = true;
              _context6.p = 2;
              _context6.n = 3;
              return (0, _decoration.decorationSalesOrderCreateApi)(this.createForm.projectId, {
                remark: this.createForm.remark,
                orderType: 'material',
                sourceType: 'admin',
                items: [{
                  productId: this.createForm.productId,
                  quantity: this.createForm.quantity,
                  salePrice: this.createForm.salePrice
                }]
              });
            case 3:
              this.$message.success('销售草稿已创建');
              this.createVisible = false;
              this.activeTab = 'sales';
              _context6.n = 4;
              return this.getList();
            case 4:
              _context6.n = 6;
              break;
            case 5:
              _context6.p = 5;
              _t5 = _context6.v;
              this.$message.error(_t5.message || '代下单失败');
            case 6:
              _context6.p = 6;
              this.creating = false;
              return _context6.f(6);
            case 7:
              return _context6.a(2);
          }
        }, _callee6, this, [[2, 5, 6, 7]]);
      }));
      function submitCreateSales() {
        return _submitCreateSales.apply(this, arguments);
      }
      return submitCreateSales;
    }()
  }
};